import { render, staticRenderFns } from "./MenuListComponent.vue?vue&type=template&id=1ab043c4&scoped=true"
import script from "./MenuListComponent.vue?vue&type=script&lang=js"
export * from "./MenuListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab043c4",
  null
  
)

export default component.exports